/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   aex\client\memberentitlementmanagement\webapi\internal\clientgeneratorconfigs\genclient.json
 */

/**
 * Information about failure of assigning extension to user
 */
export interface FailedExtensionAssignment {
    /**
     * ID of the extension
     */
    extensionId: string;
    /**
     * Reason of the assigning failure
     */
    reason: string;
}
